module.exports = __webpack_public_path__ + "images/chubb.fcc56c769c7a25f0b35ee07d12ae116e.png";